export type SimulationTableHierarchyItem = {
    dimension?: string;
    attribute_type?: string;
    ex_id?: string;
    description?: string;
};

export type SimulationTableKpiItem = {
    kpi_id?: string;
    kpi_name?: string;
    display_label?: string;
    valuePrefix?: string;
    value?: string | number | boolean;
    raw_value?: number;
    is_editable?: boolean;
    change?: number;
    updated_value?: number;
    kpi_type?: string;
    kind?: string;
};

export type SimulationTableApiRow = {
    hierarchy?: SimulationTableHierarchyItem[];
    kpi?: SimulationTableKpiItem[];
};

export type SimulationTableApiResponse = {
    data?: SimulationTableApiRow[];
    limit?: number;
    offset?: number;
    total?: number;
    status?: string;
};

export const SIMULATION_TABLE_QUERY_KEY = 'ppa-simulation-table';

export type SimulationVisibleAttributeColumn = {
    attributeKey: string;
    displayName: string;
};

export type SimulationTableGroupByItem = {
    attribute_key?: string;
    display_name?: string;
};

export type SimulationKpiKind = 'display' | 'input' | 'date' | 'checkbox';

export type SimulationVisibleKpiColumn = {
    kpiId: string;
    kind: SimulationKpiKind;
    displayName: string;
    valuePrefix?: string;
};

export const EMPTY_KPI_COLUMNS: Record<SimulationKpiKind, SimulationVisibleKpiColumn[]> = {
    display: [],
    input: [],
    date: [],
    checkbox: [],
};
